const POST_CLIENT_ITEM_ACCESS_TOKEN = 'ef122c27b4694ae3b1370fe335f732e3'; // https://rollbar.com/

export const rollbarConfig = {
  accessToken: POST_CLIENT_ITEM_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ENV,
  enabled: process.env.REACT_APP_ENV === 'production',
};
